// extracted by mini-css-extract-plugin
export default {"btn":"ModalCloseBtn_btn__gTI4W"};